import { HTMLAttributes } from 'react';
import { CTAButtonTypes } from '../../../../components/ctaButton/CTAButtonTypes';

export namespace AboutUsTypes {
  export interface IAboutUs extends HTMLAttributes<HTMLDivElement> {
    title: string;
    description: string; // html string
    theme?: 'light' | 'dark';
    customArt?: {
      show: boolean;
      images: TImageArray[];
      position: 'left' | 'right';
      maxWidth: ImageSizeTypes | 'full-size';
    };
    callToAction?: CTAButtonTypes.TCallToAction;
    variant?: 'thumbnail' | 'imageWithButton';
  }

  export type TGatsbyImageData = {
    alt: string;
    height?: number | string;
    width?: number | string;
    placeholder?: {
      fallback: string;
    };
    imgProps: {
      src: string;
    };
    sourceProps?: {
      fallback: TGatsbyImage;
      sources: [TGatsbyImage];
    };
  };

  export type TGatsbyImage = {
    sizes: string;
    src: string;
    srcSet: string;
  };

  export type TImageArray = {
    imageUrl: string;
    gatsbyImageData?: TGatsbyImageData;
  };

  export type ImageSizeTypes =
    | 16
    | 24
    | 32
    | 48
    | 64
    | 96
    | 128
    | 'square'
    | '1by1'
    | '4by3'
    | '3by2'
    | '16by9'
    | '2by1'
    | '5by4'
    | '5by3'
    | '3by1'
    | '4by5'
    | '3by4'
    | '2by3'
    | '3by5'
    | '9by16'
    | '1by2'
    | '1by3'
    | string
    | number;
}
